"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return ModelRoleVisibility;
    }
});
const _View = /*#__PURE__*/ _interop_require_default(require("~/models/View"));
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
const _globals = require("~/utils/globals");
const _NocoCache = /*#__PURE__*/ _interop_require_default(require("~/cache/NocoCache"));
const _extractProps = require("~/helpers/extractProps");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let ModelRoleVisibility = class ModelRoleVisibility {
    static async list(context, baseId) {
        const cachedList = await _NocoCache.default.getList(context, _globals.CacheScope.MODEL_ROLE_VISIBILITY, [
            baseId
        ]);
        let { list: data } = cachedList;
        const { isNoneList } = cachedList;
        if (!isNoneList && !data.length) {
            data = await _Noco.default.ncMeta.metaList2(context.workspace_id, context.base_id, _globals.MetaTable.MODEL_ROLE_VISIBILITY);
            await _NocoCache.default.setList(context, _globals.CacheScope.MODEL_ROLE_VISIBILITY, [
                baseId
            ], data, [
                'fk_view_id',
                'role'
            ]);
        }
        return data == null ? void 0 : data.map((baseData)=>new ModelRoleVisibility(baseData));
    }
    static async get(context, args, ncMeta = _Noco.default.ncMeta) {
        let data = args.fk_view_id && args.role && await _NocoCache.default.get(context, `${_globals.CacheScope.MODEL_ROLE_VISIBILITY}:${args.fk_view_id}:${args.role}`, _globals.CacheGetType.TYPE_OBJECT);
        if (!data) {
            data = await ncMeta.metaGet2(context.workspace_id, context.base_id, _globals.MetaTable.MODEL_ROLE_VISIBILITY, // args.fk_model_id
            //   ? {
            //       fk_model_id: args.fk_model_id,
            //       role: args.role
            //     }
            //   :
            {
                fk_view_id: args.fk_view_id,
                role: args.role
            });
            await _NocoCache.default.set(context, `${_globals.CacheScope.MODEL_ROLE_VISIBILITY}:${args.fk_view_id}:${args.role}`, data);
        }
        return data && new ModelRoleVisibility(data);
    }
    static async update(context, fk_view_id, role, body, ncMeta = _Noco.default.ncMeta) {
        // set meta
        const res = await ncMeta.metaUpdate(context.workspace_id, context.base_id, _globals.MetaTable.MODEL_ROLE_VISIBILITY, {
            disabled: body.disabled
        }, {
            fk_view_id,
            role
        });
        await _NocoCache.default.update(context, `${_globals.CacheScope.MODEL_ROLE_VISIBILITY}:${fk_view_id}:${role}`, {
            disabled: body.disabled
        });
        return res;
    }
    async delete(context, ncMeta = _Noco.default.ncMeta) {
        return await ModelRoleVisibility.delete(context, this.fk_view_id, this.role, ncMeta);
    }
    static async delete(context, fk_view_id, role, ncMeta = _Noco.default.ncMeta) {
        const res = await ncMeta.metaDelete(context.workspace_id, context.base_id, _globals.MetaTable.MODEL_ROLE_VISIBILITY, {
            fk_view_id,
            role
        });
        await _NocoCache.default.deepDel(context, `${_globals.CacheScope.MODEL_ROLE_VISIBILITY}:${fk_view_id}:${role}`, _globals.CacheDelDirection.CHILD_TO_PARENT);
        return res;
    }
    static async insert(context, body, ncMeta = _Noco.default.ncMeta) {
        const insertObj = (0, _extractProps.extractProps)(body, [
            'role',
            'disabled',
            'fk_view_id',
            'base_id',
            'source_id'
        ]);
        const view = await _View.default.get(context, body.fk_view_id, ncMeta);
        if (!insertObj.source_id) {
            insertObj.source_id = view.source_id;
        }
        const result = await ncMeta.metaInsert2(context.workspace_id, context.base_id, _globals.MetaTable.MODEL_ROLE_VISIBILITY, insertObj);
        insertObj.id = result.id;
        return this.get(context, {
            fk_view_id: body.fk_view_id,
            role: body.role
        }, ncMeta).then(async (modelRoleVisibility)=>{
            const key = `${_globals.CacheScope.MODEL_ROLE_VISIBILITY}:${body.fk_view_id}:${body.role}`;
            await _NocoCache.default.appendToList(context, _globals.CacheScope.MODEL_ROLE_VISIBILITY, [
                context.base_id
            ], key);
            return modelRoleVisibility;
        });
    }
    constructor(body){
        Object.assign(this, body);
    }
};
